import { Textarea } from "@/components/ui/textarea";
import { Field, useFieldError } from "@/shared/forms/Field";
import type * as React from "react";
import { useFormContext } from "react-hook-form";

type FormTextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
};

export function FormTextarea({
  name,
  label,
  hint,
  requiredMark,
  ...rest
}: FormTextareaProps) {
  const { register } = useFormContext();
  const error = useFieldError(name);

  return (
    <Field name={name} label={label} hint={hint} requiredMark={requiredMark}>
      <Textarea
        id={name}
        aria-invalid={!!error}
        {...register(name)}
        {...rest}
      />
    </Field>
  );
}
